import './TabStyles.css';
import double_rainbow from '../../imgs/diego_dub_rainbow.jpg'
import Ticker from './Ticker'
import Calendar from './Calendar'
import { FiCalendar, FiCompass, FiHeart, FiMapPin } from 'react-icons/fi'

const TabHome = () => {



    return (
        <div className='tab-wrapper'>
            <section className='hero hero-home'>
                <img className='hero-image' src={double_rainbow} alt="A rainbow stretching over Greenwood Lake and the surrounding hills" />
                <div className='hero-shade'></div>
                <div className='hero-content'>
                    <span className='eyebrow'><FiMapPin /> Greenwood Lake, New York</span>
                    <h1>Life by the lake,<br />rooted in community.</h1>
                    <p>Welcome to Indian Park — a neighbor-led community overlooking Greenwood Lake since 1936.</p>
                </div>
                <div className='hero-stats' aria-label="Community highlights">
                    <div><strong>1936</strong><span>Established</span></div>
                    <div><strong>2</strong><span>Community beaches</span></div>
                    <div><strong>100%</strong><span>Volunteer run</span></div>
                </div>
            </section>

            <Ticker />

            <section className='page-section home-intro'>
                <div className='section-heading split-heading'>
                    <div>
                        <span className='eyebrow dark'><FiCompass /> Around Indian Park</span>
                        <h2>Stay connected to what’s happening.</h2>
                    </div>
                    <p>Community gatherings, seasonal updates, and important dates are all in one place.</p>
                </div>

                <div className='calendar-shell'>
                    <div className='calendar-shell-heading'>
                        <div className='icon-tile'><FiCalendar /></div>
                        <div>
                            <span>Community calendar</span>
                            <h3>Upcoming events</h3>
                        </div>
                    </div>
                    <Calendar />
                </div>

                <div className='home-note'>
                    <FiHeart aria-hidden="true" />
                    <p><strong>Neighbors make Indian Park special.</strong> Our shared spaces and traditions are cared for by resident volunteers.</p>
                </div>
            </section>
            </div>
    )
}
export default TabHome
